import { Button } from "@/components/ui/button";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";
import type { Member } from "@medical-association/shared";
import { useState } from "react";

const MemberManagement = () => {
	const [members, setMembers] = useState<Member[]>([]);

	return (
		<div className="space-y-6">
			<div className="flex justify-between items-center">
				<h2 className="text-2xl font-semibold">Member Management</h2>
			</div>

			<Table>
				<TableHeader>
					<TableRow>
						<TableHead>Name</TableHead>
						<TableHead>Role</TableHead>
						<TableHead>Level</TableHead>
						<TableHead>Business Type</TableHead>
						<TableHead>Contact</TableHead>
						<TableHead>Actions</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{members.map((member) => (
						<TableRow key={member.id}>
							<TableCell>{member.name}</TableCell>
							<TableCell>{member.role}</TableCell>
							<TableCell>{member.level}</TableCell>
							<TableCell>{member.businessType}</TableCell>
							<TableCell>{member.contactInfo.email}</TableCell>
							<TableCell>
								<Button variant="outline" size="sm">
									Edit
								</Button>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</div>
	);
};

export default MemberManagement;
